module.exports = __webpack_public_path__ + "img/imaginative-mind.59f71f5d.svg";